// @flow

/**
 * Ajaxing SVG sprite
 */

import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

class AddSvgIconSprite extends WebComponent {

	element: HTMLElement;

	didMount() {
		let xhr = new XMLHttpRequest();
		const container = this.element;
		const path = container.getAttribute('data-url');

		if ( path === '' || path == null ) {
			if ( document.body ) document.body.classList.add('no-svg-sprite');
			throw new Error('Define `data-url` attribute with correct path to SVG sprite!');
		} else {

			if ( 'withCredentials' in xhr ) {
				xhr.withCredentials = true;
				xhr.open('GET', path, true);
			} else if ( typeof XDomainRequest != 'undefined' ) {
				xhr = new XDomainRequest();
				xhr.open('GET', path);
			} else if ( document.body ) document.body.classList.add('no-svg-sprite');

			xhr.onload = () => {
				container.innerHTML = xhr.responseText;
			};

			xhr.onerror = () => {
				if ( document.body ) document.body.classList.add('no-svg-sprite');
			};

			setTimeout(() => {
				xhr.send();
			}, 0);
		}
	}

}

export default AddSvgIconSprite;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/AddSvgIconSprite.js